import { Menu } from "lucide-react";
import React from "react";
import { sendMessageToParent } from "src/helpers/common";
import { POST_MESSAGE_EVENTS } from "src/constants/common";

const InvalidProgramPage: React.FC = () => {
  const handleMenuClick = () => {
    sendMessageToParent(POST_MESSAGE_EVENTS.SHOW_MENU_DRAWER);
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <button
        className="z-10 absolute top-4 left-4 p-2 rounded-full active:bg-gray-200"
        onClick={handleMenuClick}
      >
        <Menu />
      </button>
      <div className="text-center">
        <h1 className="text-2xl font-bold">Invalid Program</h1>
        <p className="text-gray-500">
          The program you are trying to access is invalid.
        </p>
      </div>
    </div>
  );
};

export default InvalidProgramPage;
